import type { FindingOut } from '@/api/types';
import { Badge } from '@/components/ui/badge';

export function CarriedForwardPill({ finding }: { finding: FindingOut }) {
  if (!finding.auto_carried_forward) return null;
  const sourceId = finding.carried_forward_from_finding_id;
  const reviewer = finding.reviewer_alias;
  const reviewed = finding.reviewed_at
    ? new Date(finding.reviewed_at).toLocaleDateString()
    : null;
  const lines = [
    'Disposition auto-carried from a prior run.',
    reviewer && reviewed ? `${finding.status} by ${reviewer} on ${reviewed}.` : null,
    sourceId ? `Source finding: ${sourceId.slice(0, 12)}…` : null,
    'Approve / reject / unreview clears this flag.',
  ].filter(Boolean) as string[];
  return (
    <Badge
      variant="outline"
      title={lines.join('\n')}
      className="border-brand-slate/30 bg-muted/40 font-normal text-brand-slate"
    >
      ↩ carried
    </Badge>
  );
}
